// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"152":"base","332":"detail"}[chunkId] + "." + {"152":"8769f69a","332":"d47a3e72"}[chunkId] + ".css";
};